const masterclass = {
    "LBL_PAGE_TITLE":"Мастерклас"
};
export default masterclass;